"use client";

import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefitsList = ["Interfaz de llamadas unificada", "Colaboración fluida entre equipos", "Seguridad de grado empresarial", "Reducción de costos de infraestructura", "Presencia en tiempo real", "Productividad mejorada"];
export default function IntegrationBenefits() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261681" id="integration-benefits" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="page-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={leftRef} className={`flex flex-col gap-8 transition-all duration-1000 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <span className="text-primary font-semibold tracking-wider uppercase text-sm block font-default">
                Beneficios de Integración
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-default leading-tight">
                Optimice su comunicación. <span className="text-primary">Potencie su empresa.</span>
              </h2>
              <p className="text-muted-foreground text-lg font-sans max-w-xl">
                Nuestra plataforma integra todas sus herramientas de comunicación en un solo ecosistema seguro y eficiente, diseñado para el crecimiento moderno.
              </p>
            </div>

            <ul className="flex flex-col gap-5">
              {benefitsList.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                    <CircleCheck className="w-5 h-5 text-primary" />
                  </div>
                  <span className="text-foreground font-medium font-sans text-lg">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div ref={rightRef} className={`relative transition-all duration-1000 delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="absolute -inset-4 bg-primary/20 blur-3xl -z-10"></div>

            {}
            <div className="rounded-lg border border-border/50 bg-card/30 backdrop-blur-md p-3 shadow-2xl relative overflow-hidden">
              <div className="absolute inset-0 bg-primary/20 z-10 pointer-events-none"></div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/enterprise_office_collaboration.png" alt="Profesionales en oficina moderna utilizando sistemas de comunicación unificada" className="rounded-md w-full h-auto object-cover shadow-md" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/enterprise_office_collaboration.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/enterprise_office_collaboration.png-wvc-sizes" loading="lazy" src="https://avtecsa.com/wp-content/uploads/2026/05/teamsAvtec.png" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}